import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-flex ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-anchor"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
            >
                <span class="ns-color-black ns-font-5">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                {/* <Icon name="arrow" className="ns-absolute" /> */}
                <span class="mobile-facets__arrow">
                    <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                        </path>
                    </svg>
                </span>
            </a>
            <div class="ns-sidebar-submenu ns-d-none">
            <a
                class="ns-d-inline-flex ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-anchor"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
            >
                <svg style="transform:rotate(180deg);margin-right: 1rem;" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                    </path>
                </svg>
                <span class="ns-color-black ns-font-5">{facet.name}</span>
            </a>
                
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facet.data?.map(value => (
                        <li
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                {value.count}
                            </span> */}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
